import { Grid } from "@mui/material";
import { RoleComponent } from "components/UtilsComponent/RoleComponent";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useDashboardWorkItemStats } from "services/input-core/dashboard/get-dashboard--workitem-stats copy";
import { useSubscription } from "store/auth/auth-store";
import { ActivitiesNeedManualApproval } from "./components/ActivitiesNeedManualApproval";
import ActivitiesRequiringDepartmentActionCard from "./components/ActivitiesRequiringDepartmentActionCard";
import ProcessListSection from "./components/ProcessListSection";
import Stats from "./components/Stats";
import { useDashboardActivityItemStats } from "services/input-core/dashboard/get-dashboard-activityItem-stats";
import ActivitiesRequiringBuyerActionCard from "./components/ActivitiesRequiringBuyerActionCard";
import { useKeycloak } from "@react-keycloak/web";
import ReprocessMonitor from "./components/ReprocessMonitor";
import Monitor from "./components/Monitor";

export default function Dashboard() {
  const { t } = useTranslation("dashboard");
  const { isKuo } = useSubscription();
  const { keycloak } = useKeycloak();
  const haveReprocessMonitor = keycloak?.hasResourceRole(
    "Reprocess Monitor",
    "uverify"
  );

  const isOnlyBuyer =
    keycloak.hasResourceRole("buyer", "uverify") &&
    !keycloak.hasRealmRole("approver") &&
    !keycloak.hasRealmRole("superUser");

  const {
    data: processes,
    isLoading: isProcessesLoading,
  } = useDashboardWorkItemStats();

  const {
    data: activityItemStats,
    isLoading: isActivityItemStatsLoading,
  } = useDashboardActivityItemStats();

  return (
    <div id='dashboard-content'>
      <Stats />
      <RoleComponent
        realmRoles={[
          "hr",
          "ehs",
          "legal",
          "insurance",
          "credenciamento",
          "gestaoTerceiros",
          "ssma",
        ]}
      >
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <ActivitiesRequiringDepartmentActionCard color='info' icon={""} />
          </Grid>
        </Grid>
      </RoleComponent>

      {isOnlyBuyer && !isKuo && (
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <ActivitiesRequiringBuyerActionCard color='info' icon={""} />
          </Grid>
        </Grid>
      )}

      {isKuo && (
        <ActivitiesNeedManualApproval
          processes={processes}
          isLoading={isProcessesLoading}
        />
      )}

      <ProcessListSection
        activityItemStats={activityItemStats}
        processes={processes}
        isProcessesLoading={isProcessesLoading || isActivityItemStatsLoading}
      />

      <Grid container spacing={2}>
        {haveReprocessMonitor && (
          <Grid item xs={12} sm={6} md={6}>
            <h3>{t("reprocess-monitor")}</h3>
            <ReprocessMonitor />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={haveReprocessMonitor ? 6 : 12}
          md={haveReprocessMonitor ? 6 : 12}
        >
          <h3>{t("expiration-monitor")}</h3>
          <Monitor />
        </Grid>
      </Grid>
    </div>
  );
}
